import Switch from 'components/switch/Switch';
import AiSuggestedMark from './AiSuggestedMark';
import {
  REFERENTIAL_STATUS,
  isAiRiskFactor,
} from './qualificationRequirements';
import { qualificationText } from './qualificationTexts';

const riskText = (key, values) => qualificationText(`risk.${key}`, values);

// Same article as the job description's risk step.
const ARTICLE_L4161_1_URL =
  'https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000035640694';
const POSITION_AT_RISK_SWITCH_ID = 'qualification-position-at-risk';

const RiskFactors = ({ risk, riskyPositions, onFactorToggle }) => {
  if (riskyPositions.status === REFERENTIAL_STATUS.LOADING) {
    return (
      <div
        aria-busy="true"
        aria-label={riskText('loading')}
        className="h-32 rounded-lg skeleton-bar"
      />
    );
  }
  if (riskyPositions.status === REFERENTIAL_STATUS.FAILED) {
    return (
      <p
        data-testid="qualification-risk-list-error"
        className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700"
      >
        {riskText('listError')}
      </p>
    );
  }
  if (riskyPositions.items.length === 0) {
    return <p className="text-sm text-gray-500">{riskText('empty')}</p>;
  }
  return (
    <fieldset className="min-w-0">
      <legend className="sr-only">{riskText('factorsLegend')}</legend>
      <ul className="flex flex-col gap-2">
        {riskyPositions.items.map(({ besttField, name }) => {
          const isAi = isAiRiskFactor(risk, besttField);
          return (
            <li
              key={besttField}
              data-testid="qualification-risk-factor"
              data-ai={isAi ? 'true' : 'false'}
              className={`flex items-center gap-3 rounded-lg border px-4 py-3 ${
                isAi ? 'border-yellow-500' : 'border-gray-100'
              }`}
            >
              {/* The mark stays outside the label: clicking it must not toggle the box. */}
              <label className="flex min-w-0 flex-1 cursor-pointer items-center gap-3">
                <input
                  type="checkbox"
                  className="checkbox-primary shrink-0"
                  checked={Boolean(risk.penibilite[besttField])}
                  onChange={() => onFactorToggle(besttField)}
                />
                <span className="min-w-0 break-words text-sm text-gray-900">
                  {name}
                </span>
              </label>
              {isAi && <AiSuggestedMark align="end" />}
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
};

/** Whether the job is at risk, and its factors, chosen from the riskypositions list. */
const QualificationRiskTab = ({
  risk,
  riskyPositions,
  onPositionAtRiskChange,
  onFactorToggle,
}) => (
  <div className="flex flex-col gap-4">
    <div className="flex items-center justify-between gap-4 rounded-lg border border-gray-100 px-4 py-3">
      <div className="flex min-w-0 flex-col gap-0.5">
        <label
          htmlFor={POSITION_AT_RISK_SWITCH_ID}
          className="cursor-pointer text-sm font-medium text-gray-900"
        >
          {riskText('question')}
        </label>
        <a
          href={ARTICLE_L4161_1_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="w-fit text-sm text-gray-500 hover:underline"
        >
          {riskText('articleLink')}
        </a>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {risk.isSwitchAi && <AiSuggestedMark align="end" />}
        <Switch
          id={POSITION_AT_RISK_SWITCH_ID}
          checked={risk.positionAtRisk}
          onChange={onPositionAtRiskChange}
        />
      </div>
    </div>
    {risk.positionAtRisk && (
      <RiskFactors
        risk={risk}
        riskyPositions={riskyPositions}
        onFactorToggle={onFactorToggle}
      />
    )}
  </div>
);

export default QualificationRiskTab;
